import { useContext } from 'react';
import { CompareCartContext, CompareCartState } from './CompareCartContext';

export const useCompareCart = (): CompareCartState => {
  const context = useContext(CompareCartContext);
  if (context === undefined) {
    throw new Error('useCompareCart must be used within a CompareCartProvider');
  }
  return context;
};
